import "antd/es/list/style";
import _List from "antd/es/list";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import React from 'react';
import Spin from '@osui/spin';
import hoistNonReactStatics from 'hoist-non-react-statics';

function List(props) {
  var loading = props.loading;
  var innerLoading = _typeof(loading) === 'object' ? _objectSpread({
    indicator: /*#__PURE__*/React.createElement(Spin, null)
  }, loading) : {
    indicator: /*#__PURE__*/React.createElement(Spin, null),
    spinning: loading !== null && loading !== void 0 ? loading : false
  };
  return /*#__PURE__*/React.createElement(_List, _objectSpread(_objectSpread({}, props), {}, {
    loading: innerLoading
  }));
}

hoistNonReactStatics(List, _List);
export default List;
//# sourceMappingURL=index.js.map